var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1StTierSlice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.6567 30.1939C17.2138 30.3125 15.7989 30.3167 14.4682 30.2392C14.0017 30.212 13.5783 30.1764 13.2051 30.1365C12.9776 30.1122 12.8151 30.0914 12.7246 30.0781C12.3468 30.0227 12.0732 29.7394 12.031 29.3599C12.0209 29.269 12.0058 29.1058 11.9894 28.8777C11.9625 28.5033 11.9418 28.0789 11.9309 27.6118C11.8998 26.2792 11.9534 24.8652 12.1223 23.4273C12.6148 19.2337 13.964 15.6757 16.4904 13.236C20.6287 9.23968 26.7826 8.89853 30.2354 12.4741C33.6883 16.0496 33.1326 22.1878 28.9942 26.1841C26.4679 28.6238 22.865 29.848 18.6567 30.1939Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0324 24.7659C17.7588 26.1104 16.3978 27.3352 15.0365 28.4193C14.5592 28.7993 14.1152 29.1351 13.7153 29.424C13.4715 29.6 13.2939 29.723 13.1934 29.7901C12.7735 30.07 12.2265 30.07 11.8066 29.7901C11.7061 29.723 11.5285 29.6 11.2847 29.424C10.8848 29.1351 10.4408 28.7993 9.96353 28.4193C8.60218 27.3352 7.24125 26.1104 5.96756 24.7659C2.253 20.845 0 16.7145 0 12.5C1.02871e-07 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 16.7145 22.747 20.845 19.0324 24.7659Z",
    fill: "#F15D2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.5C9.73858 17.5 7.5 15.2614 7.5 12.5C7.5 9.73858 9.73858 7.5 12.5 7.5C15.2614 7.5 17.5 9.73858 17.5 12.5C17.5 15.2614 15.2614 17.5 12.5 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1StTierSlice);
export default __webpack_public_path__ + "static/media/1st_Tier_Slice.2affd9069c24b083bf6903606cc39b02.svg";
export { ForwardRef as ReactComponent };